<button
  [class]="classes()"
  [class.bg-base-300!]="forceBaseBgColor()"
  [attr.aria-label]="ariaLabel()"
  [attr.data-testid]="testId()"
  [disabled]="isDisabled()"
  (click)="onClick($event)"
>
  @if (states() === 'loading') {
    <span class="loading loading-spinner"></span>
  }
  <ng-content />
</button>
